import { Option } from 'components/elements/ArchidektDropdown/types'

import { useAdFree } from 'hooks/adFree'
import { useRandomType } from 'hooks/useCanary'

import Analytics from 'utils/googleAnalytics'

import styles from './generatePatreonLinks.module.scss'

const CANARY_OPTIONS = [
  { label: 'Go ad-free with Patreon!', id: 1 },
  { label: 'Ad-free for $2/month', id: 2 },
  { label: 'Ad-free for $20/year', id: 3 },
]

const sevenDays = new Date(Date.now() + 1000 * 60 * 60 * 24 * 7)

export const useGeneratePatreonLinkInfo = (from: string): Option => {
  const adFree = useAdFree()
  const optionIndex = useRandomType('patreon-link', [0.33, 0.66, 1], sevenDays)

  const selectedOption = CANARY_OPTIONS[optionIndex] || CANARY_OPTIONS[0]

  return {
    icon: 'patreon',
    label: selectedOption.label,
    to: 'https://www.patreon.com/archidekt/membership',
    onClick: () => Analytics.signalEvent(`Patreon clicked - ${selectedOption.id} - ${from}`),
    target: '_blank',
    hidden: adFree,
    className: styles.patreon,
  }
}
